module.exports = function (FiltersService) {
	return {
		restrict: 'E',
		scope: {
			filterData: '='
		},
		link(scope) {
			scope.brands = {};
			scope.filtersService = FiltersService;

      scope.applySelectedFilter = function (filter) {
				scope.filtersService.applyFilter(scope.filterData.Name, {
					Term: filter.Term
				});
			};

			scope.$watch('filterData', function (brands) {
				if (brands) {
					scope.brands = scope.filtersService.groupByAlphabet(scope.filterData.Results);
				}
      });
		},
		template: require('./filter-brand-mob-template.html')
	};
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/filters/advance-filter/filter-brand-mob-directive.js
 **/